"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var getValidProps_1 = require("@helpscout/react-utils/dist/getValidProps");

var classNames_1 = require("../../utilities/classNames");

var component_1 = require("../../utilities/component");

var utils_1 = require("./utils");

var Item_css_1 = require("./styles/Item.css");

var Item =
/** @class */
function (_super) {
  __extends(Item, _super);

  function Item() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Item.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        className = _a.className,
        inline = _a.inline,
        rest = __rest(_a, ["children", "className", "inline"]);

    var componentClassName = classNames_1.classNames('c-Flexy__item', inline ? 'is-inlineItem' : 'is-defaultItem', className);
    return React.createElement(Item_css_1.ItemUI, __assign({}, getValidProps_1.default(rest), {
      className: componentClassName
    }), children);
  };

  Item.defaultProps = {
    inline: false
  };
  return Item;
}(React.PureComponent);

component_1.namespaceComponent(utils_1.COMPONENT_KEY.Item)(Item);
exports.default = Item;